import classNames from 'classnames';
import { HTMLProps } from 'react';

import textBaseStyle from '../Text/text-base.module.css';
import style from './radio.module.css';

interface RadioProps extends Omit<HTMLProps<HTMLInputElement>, 'type' | 'value'> {
  label: string;
  name: string;
  options: {
    label: string;
    value: string;
  }[];
}

const Radio = ({
  label,
  name,
  options,
  ...inputProps
}: RadioProps) => {
  const inputLabel = inputProps.required && !label.endsWith('*')
    ? `${label} *`
    : label;

  return (
    <fieldset className={style.fieldset}>
      <legend
        className={classNames(
          textBaseStyle.fontSize16,
          textBaseStyle.fontWeight700,
        )}
      >
        {inputLabel}
      </legend>

      <div className={style.options}>
        {options.map(option => (
          <label
            className={classNames(textBaseStyle.fontSize15, style.label)}
            key={option.value}
          >
            <input
              className={style.input}
              name={name}
              type="radio"
              value={option.value}
              {...inputProps}
            />

            {option.label}
          </label>
        ))}
      </div>
    </fieldset>
  );
};

export default Radio;
